"use client"

import { createContext, useCallback, useContext, useEffect, useState } from "react"
import { apiClient } from "../services/apiClient"

const AuthContext = createContext()

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    checkAuthStatus()
  }, [])

  const checkAuthStatus = async () => {
    try {
      const token = localStorage.getItem("auth_token")
      if (token) {
        const response = await apiClient.getCurrentUser()
        setUser(response.user)
      }
    } catch (error) {
      console.error("Auth check failed:", error)
      localStorage.removeItem("auth_token")
    } finally {
      setIsLoading(false)
    }
  }

  const login = async (email, password) => {
    try {
      const response = await apiClient.login(email, password)
      setUser(response.user)
    } catch (error) {
      throw error
    }
  }

  const logout = useCallback(() => {
    apiClient.logout()
    setUser(null)
  }, [])

  useEffect(() => {
    apiClient.setUnauthorizedHandler(logout)
  }, [logout])

  const refreshUser = async () => {
    try {
      const response = await apiClient.getCurrentUser()
      setUser(response.user)
    } catch (error) {
      console.error("Failed to refresh user:", error)
    }
  }

  return <AuthContext.Provider value={{ user, isLoading, login, logout, refreshUser }}>{children}</AuthContext.Provider>
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider")
  }
  return context
}
